import { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Chip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Observation from '../../../../../components/Advanced/Modal/PatientModal/Observations';

const StatusMoods = [
  'NOT OUR PATIENT', 'ALREADY HAS AN APPOINTMENT', 'OPEN', 'INSURANCE CHANGED', 'OTHER PCP', 'PENDING', 'REFUSED'
]

const NoRecentVisitDetail = ({ modificar = {}, onSave}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [comments, setComments] = useState( []);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [newComment, setNewComment] = useState('');
  const timestamp = new Date().toLocaleString(); 
  const [tags, setTags] = useState([]);
  const [input, setInput] = useState("");
 
  const [form, setForm] = useState({
    cipId: modificar.cipId,
    memberFullName: modificar.memberFullName,
    insureStatus: modificar.insureStatus,
    dateOfBirth: modificar.dateOfBirth,
    email: modificar.email,
    phoneNumber: modificar.phoneNumber, 
    dateOfLastVisit: modificar.dateOfLastVisit,
    timeSinceLastVisit: modificar.timeSinceLastVisit,
    pcpAssigned: modificar.pcpAssigned,
    medicalCenter: modificar.medicalCenter, 
    status: modificar.status,
    welcomeCampaign: modificar.welcomeCampaign,
    CommentsCount: modificar.CommentsCount,
    attendingPhysicianProvider: modificar.attendingPhysicianProvider,
  });

  const handleAddComment = () => {
    const timestamp = new Date().toLocaleString();
    const updatedComments = [...comments, { Timestamp: timestamp, Comments: newComment, attendingPhysicianProvider: form.attendingPhysicianProvider }];
    setComments(updatedComments);
    handleChange('CommentsCount', updatedComments)
    setNewComment('');
    setOpenCommentDialog(false);
  };

  useEffect(() => {
    const partes = (modificar?.welcomeCampaign ?? "").split(";");
    setTags(partes);
  }, [modificar]);
  

  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key === ',') && input.trim() !== "") {
      e.preventDefault();
      const newTag = input.trim();

      if (!tags.includes(newTag)) {
        const updatedTags = [...tags, newTag];
        setTags(updatedTags);
        SaveWelcom(updatedTags);
      }

      setInput("");
    }
  };
  const handleDelete = (tagToDelete) => {
    const updatedTags = tags.filter(tag => tag !== tagToDelete);
    setTags(updatedTags);
    SaveWelcom(updatedTags);
  };


  const handleSave = () => {
    const envio = form;
    const unido = envio.welcomeCampaign.join(";");
    envio.welcomeCampaign = unido;
    onSave(envio);
  };

  const SaveWelcom  = (Welcome) => {
    setForm((prevForm) => ({
      ...prevForm,
      welcomeCampaign: Welcome
    }));
  }

  

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">No Recent Visit Details</Typography>
        {!isEditing && (
          <Button variant="contained" startIcon={<EditIcon />} onClick={() => setIsEditing(true)}>Edit</Button>
        )}
      </Box>
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
            <Grid container spacing={2}>
              <Grid item width="100%"><Typography><strong>Member Full Name:</strong> {modificar.memberFullName}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Insurance Status:</strong> {form.insureStatus}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>DOB:</strong> {modificar.dateOfBirth}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Email:</strong> {modificar.email}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Phone Number:</strong> {form.phoneNumber}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Time Since Last Visit:</strong> {modificar.timeSinceLastVisit}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>PCP Full Name:</strong> {form.pcpAssigned}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Office Location:</strong> {modificar.medicalCenter}</Typography></Grid>
                <TextField
                  disabled={!isEditing}
                  label="status"
                  select
                  fullWidth
                  value={form.status}
                  onChange={e => handleChange('status', e.target.value)}
                >
                  {StatusMoods.map(opt => (
                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <TextField
                label="Welcome Campaign Options"
                disabled={!isEditing}
                fullWidth
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Press Enter or comma to add"
                variant="outlined"
              />

            <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {tags.map((tag, index) => (
                <Chip
                  key={index}
                  label={tag}
                  onClick={() => {}}
                  onDelete={() => handleDelete(tag)}
                  color="primary"
                  variant="outlined"
                />
              ))}
            </Box>
        </Grid>
      </Paper>

      {/* Related Comments */}
      <Paper variant="outlined" sx={{ p: 4, mb: 3}}>
        <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
          <Box sx={{ flex: 1, p: 2, overflowY: "auto" }}>
            <Observation cipId={modificar.cipId} />
          </Box>
        </Box>
      </Paper>

      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid item width="100%"><Typography><strong>TimesTamp:</strong> {timestamp}</Typography></Grid>
      </Paper>
      {isEditing && (
          <Box display="flex" justifyContent="flex-end" sx={{ 
                mt: 2, // espacio arriba (theme spacing * 2 = 16px)
            }}>
            <Button variant="outlined" onClick={() => setIsEditing(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSave}>Save</Button>
          </Box>
        )}

      {/* Add Comment Dialog */}
      <Dialog open={openCommentDialog} onClose={() => setOpenCommentDialog(false)}>
        <DialogTitle>Add Comment</DialogTitle>
        <DialogContent>
          <TextField
            label="Comment"
            fullWidth
            multiline
            rows={4}
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCommentDialog(false)}>Cancel</Button>
          <Button onClick={handleAddComment} variant="contained">Add</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default NoRecentVisitDetail;
